<template>
  <div
    class="scrubber-container"
    v-on:mousedown="mouseDown"
    :style="{ left: scrubberPos }"
  >
    <div class="scrubber__stick"></div>
    <div class="scrubber__time">
      <div>{{ currentFormattedTime }}</div>
      <div>{{ duration }}</div>
    </div>
  </div>
</template>

<style scoped>
@import "./styles.css";
</style>

<script>
import moment from "moment";
export default {
  name: "bg-scrubber",
  props: ["videoRef", "currentTime", "scrubberTimeChange"],
  data() {
    return {
      isMouseDown: false,
      scrubberPos: "0%",
      currentFormattedTime: this.convertToMmSs(this.currentTime),
      width: this.videoRef.clientWidth,
      duration: "",
    };
  },
  created() {
    if (this.currentTime !== 0) {
      this.handleCurrentTimeChange(this.currentTime);
    }
    this.videoRef.addEventListener("loadedmetadata", (e) => {
      this.duration = moment(0)
        .add(this.videoRef.duration, "seconds")
        .format("mm:ss");
    });
  },
  methods: {
    convertToMmSs(newVal) {
      const s = parseInt(newVal % 60);
      const m = parseInt((newVal / 60) % 60);
      const time = moment().seconds(s).minutes(m).format("mm:ss");
      return time;
    },
    handleBounds(time) {
      if (time > 100) {
        return 100;
      } else if (time < 0) {
        return 0;
      } else {
        return time;
      }
    },
    mouseDown(event) {
      // enable scrubbing
      this.isMouseDown = true;
      document.body.style.cursor = "grabbing";
      // remember the initial mouse position when the scubbing started

      document.addEventListener("mousemove", this.handleMouseMove);
      document.addEventListener("mouseup", this.handleMouseUp);
    },
    handleMouseMove(event) {
      if (this.isMouseDown) {
        var newPercentage = (event.clientX - 314) / this.width;
        this.scrubberPos = this.handleBounds(newPercentage * 100) + "%";
        this.scrubberTimeChange(newPercentage);
      }
    },
    handleMouseUp: function ($event) {
      this.isMouseDown = false;
      document.body.style.cursor = "default";
    },
    handleCurrentTimeChange(newVal) {
      this.scrubberPos =
        this.handleBounds(newVal / this.videoRef.duration) * 100 + "%";
      const s = parseInt(newVal % 60);
      const m = parseInt((newVal / 60) % 60);
      this.currentFormattedTime = this.convertToMmSs(newVal);
    },
  },
  watch: {
    currentTime: function (newVal) {
      this.handleCurrentTimeChange(newVal);
    },
    duration: function (videoRef) {},
  },
};
</script>
